import _Overlay from './Overlay';

import './style';

export const Overlay = _Overlay;
export type { OverlayProps } from './Overlay';

export default Overlay;
